import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import { Grid, Tabs, Tab } from "@material-ui/core";
import { useTable, useRowSelect, useSortBy, useFilters } from "react-table";
import urlLinks from "../../UrlLinks";
import Axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import NoRecord from "./assets/noRecord.svg";
import styles from "./index.module.scss";
import ScaleLoader from "react-spinners/ScaleLoader";
import { AppData } from "../../context/context";
import { useContext } from "react";
import OnboardingModal from "../../Utils/dialogs/OnboardingModal";
import { AuthContext } from "../../services/AuthProvider";
import SearchBar from "../../Utils/functions/SearchBar";
import ActionsDropdown from "../../Utils/functions/ActionsDropdown";
import JobFilter from "../../Utils/FilterComponents/JobFilter";
import UrlLinks from "../../UrlLinks";
import Pagination from "../../Utils/Pagination";
import * as XLSX from "xlsx";
import moment from "moment";
import { recruitmentDashboardColumns } from "../../Utils/ColumnTemplate";
import CallInitiatedModal from "./components/CallInitiatedModal";
import HistoryModal from "./components/HistoryModal";

const Styles = styled.div`
  padding: 1rem;
  font-family: "Inter";
  .tableContainer {
    overflow-x: auto;
    border: 1px solid #cfcfcf;
    width: 100%;
    max-height: 60vh;
    overflow-y: auto;
  }
  .tableContainer::-webkit-scrollbar {
    width: 0.75em;
    height: 0.75em;
  }
  .tableContainer::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }
  .tableContainer::-webkit-scrollbar-thumb {
    background-color: darkgrey;
  }
  table {
    border-spacing: 0;
    width: 100%;
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    th {
      :last-child {
        border-left: 0;
      }
      background-color: #1c4980 !important;
      color: #ffffff;
    }
    th,
    td {
      padding: 20px 15px;
    }
    td {
      margin: 0;
      background-color: white;
      nth-last-child(2) {
        border-right: 0;
      }
      :last-child {
        border-right: 0;
      }
      input {
        font-size: 1rem;
        padding: 0;
        margin: 0;
        border: 0;
      }
    }
  }
  .pagination {
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 16px;
  }
`;

const useStyles = makeStyles((theme) => ({
  actionButton: {
    "& .MuiSelect-selectMenu": {
      border: "1px solid #1C4980",
      color: "#1C4980",
    },
    "& .MuiSelect-icon": {
      top: "calc(50% - 10px)",
    },
    "& .MuiSelect-iconOutlined": {
      right: 0,
      color: "#1C4980",
    },
    "& .css-i4bv87-MuiSvgIcon-root": {
      fontSize: "20px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1C4980",
    },
  },
  tabs: {
    "& .MuiTabs-flexContainer": {
      flexWrap: "wrap",
    },
    "& .MuiTab-root": {
      minWidth: "auto",
    },
  },
}));

const RecruitmentDashboard = (props) => {
  const classes = useStyles();
  const { showToast } = useContext(AuthContext);
  const { userAction } = useContext(AppData);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  const [jobList, setJobList] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [isInitiated, setIsInitiated] = useState({ id: "", flag: false });
  const [selectedJobOption, setSelectedJobOption] = useState({
    id: "all",
    name: "Select Job",
  });
  const [selectedBotOption, setSelectedBotOption] = useState({
    id: "all",
    name: "Choose Bot",
  });
  const [searchBy, setSearchBy] = useState("");
  const [uploadAction, setUploadAction] = useState(-1);
  const [tabValue, setTabValue] = useState(0);
  const [openUploadLeadModal, setOpenUploadLeadModal] = useState(false);

  const tabsData = useMemo(
    () => [
      { label: "All Leads", value: 0 },
      { label: "Leads to Process", value: 1 },
      { label: "Accepted", value: 2 },
      { label: "Rejected", value: 3 },
      { label: "DNR", value: 4 },
      { label: "Incomplete", value: 5 },
    ],
    []
  );

  const actionList = [
    {
      value: "initiateCall",
      label: "Initiate Call",
    },
    {
      value: "exportLeads",
      label: "Export Leads",
    },
  ];

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const a11yProps = (index) => ({
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  });

  const columns = useMemo(() => {
    const baseColumns = recruitmentDashboardColumns().filter(Boolean);

    if (tabValue === 0) {
      baseColumns.push({
        Header: "Status",
        accessor: "callStatus",
        defaultCanFilter: false,
        defaultCanSort: false,
      });
    }
    return baseColumns;
  }, [tabValue, userAction.edit]);

  const handleSearchClose = () => {
    setSearchBy("");
    getPaymentListing(perPage, currentPage, true);
  };

  const handleActions = (event) => {
    const val = event.target.value;
    switch (val) {
      case "initiateCall": {
        setOpenUploadLeadModal(true);
        break;
      }
      case "exportLeads": {
        handleExportLeads();
        break;
      }
      default:
        break;
    }
    setUploadAction(-1);
  };

  // Function to export leads data to Excel
  const handleExportLeads = () => {
    // Build the API URL with all current filters
    const exportUrl = `${urlLinks.baseUrl}${urlLinks.ringgaiUrls.mainListing}?agent_id=${selectedBotOption.id}&export=1&callStatus=${tabValue}`;

    Axios.post(exportUrl)
      .then((response) => {
        const responseData = response.data.response;
        if (!responseData || responseData.length === 0) {
          showToast("error", "No data available to export.");
          return;
        }

        // Parse dynamic analysisData JSON string into flat key-value columns
        const parseAnalysisData = (analysisDataStr) => {
          if (!analysisDataStr) return {};
          try {
            const parsed = JSON.parse(analysisDataStr);
            const result = {};
            const flatten = (obj, prefix = "") => {
              Object.entries(obj).forEach(([key, value]) => {
                const colName = prefix ? `${prefix}_${key}` : key;
                let nested = null;
                try {
                  nested = typeof value === "string" ? JSON.parse(value) : null;
                } catch {
                  nested = null;
                }
                if (nested && typeof nested === "object" && !Array.isArray(nested)) {
                  flatten(nested, colName);
                } else {
                  result[colName] = value;
                }
              });
            };
            flatten(parsed);
            return result;
          } catch {
            return {};
          }
        };

        // Format data for Excel export
        const excelData = responseData.map((el) => ({
          Name: el.name || "-",
          "Phone Number": el.phoneNumber || "-",
          "Calling Date": moment(el.calledOnDate).isValid()
            ? moment(el.calledOnDate).format("DD/MM/YYYY hh:mm a")
            : "-",
          "Call Attempts": el.callAttempts || "-",
          "Call Status":
            el.callStatus === 1
              ? "Leads to process"
              : el.callStatus === 2
                ? "Accepted"
                : el.callStatus === 3
                  ? "Rejected"
                  : el.callStatus === 4
                    ? "DNR"
                    : el.callStatus === 5
                      ? "Incomplete"
                      : "",
          ...parseAnalysisData(el.analysisData),
        }));

        // Create workbook and worksheet
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(excelData);

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "Leads Data");

        // Generate filename with current tab name
        const currentTabName =
          tabsData.find((tab) => tab.value === tabValue)?.label || "Leads";
        const fileName = `${currentTabName}_Export_${new Date().toISOString().split("T")[0]
          }.xlsx`;

        // Download the file
        XLSX.writeFile(workbook, fileName);
        showToast("success", "Leads exported successfully!");
      })
      .catch((error) => {
        console.log(error);
        showToast("error", "Failed to export leads. Please try again.");
      });
  };

  //Function to create table data
  const makeData = (response) => {
    let extractedData = [];
    response.map((el) => {
      extractedData.push({
        callAttempts: el.callAttempts || "-",
        calledOnDate: moment(el.calledOnDate).isValid()
          ? moment(el.calledOnDate).format("DD/MM/YYYY hh:mm a")
          : "-",
        name: el.name || "-",
        phoneNumber: el.phoneNumber || "-",
        userId: el.userId || "-",
        callStatus:
          el.callStatus === 1
            ? "Leads to process"
            : el.callStatus === 2
              ? "Accepted"
              : el.callStatus === 3
                ? "Rejected"
                : el.callStatus === 4
                  ? "DNR"
                  : el.callStatus === 5
                    ? "Incomplete"
                    : "",
      });
      return true;
    });
    return extractedData;
  };

  const updateMyData = () => {
    getPaymentListing(perPage, currentPage);
  };

  const getPaymentListing = (rows, pageNo, isFromSearchClose = false) => {
    if (selectedBotOption.name === "Choose Bot") return;

    setLoading(true);
    Axios.post(
      `${urlLinks.baseUrl}${urlLinks.ringgaiUrls.mainListing}?agent_id=${selectedBotOption.id
      }&callStatus=${tabValue}&page_no=${pageNo - 1}&rows=${rows}${!isFromSearchClose ? `${searchBy ? `&search_by=${searchBy}` : ""}` : ""
      }`
    )
      .then((response) => {
        if (response.data.response) {
          setTotalRows(response.data.response.totalElements || 0);
          setTotalPages(response.data.response.totalPages || 0);
          if (currentPage > response.data.response.totalPages) {
            setCurrentPage(1);
          }
          setData(makeData(response.data.response.content || []));
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handlePageChange = (page) => {
    getPaymentListing(perPage, page);
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage) => {
    getPaymentListing(newPerPage, 1);
    setPerPage(newPerPage);
    setCurrentPage(1);
  };

  useEffect(() => {
    getPaymentListing(perPage, 1);
    setCurrentPage(1);
  }, [localStorage.getItem("roleType"), tabValue, selectedBotOption]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state: { selectedRowIds },
  } = useTable(
    {
      columns,
      data,
      initialState: {
        hiddenColumns: [""],
      },
      updateMyData,
      showToast,
      setLoading,
      manualSortBy: true,
    },
    useFilters,
    useSortBy,
    useRowSelect
  );

  const table = (
    <div className={`tableContainer ${styles.tableContainer}`}>
      <table {...getTableProps()} className="table">
        <thead className="thead">
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  className={
                    column.render("Header") === "Worker Id"
                      ? "stickWorkerIdnewMatch zIndex1080 header"
                      : column.id === "selection"
                        ? "stickCheckbox zIndex1080 header"
                        : "header"
                  }
                >
                  <span {...column.getSortByToggleProps()}>
                    {column.render("Header")}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        {
          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} className="row">
                  {row.cells.map((cell) => {
                    return (
                      <td
                        {...cell.getCellProps()}
                        className={
                          cell.column.Header === "Worker Id"
                            ? "stickWorkerIdnewMatch  zIndex540"
                            : cell.column.id === "selection"
                              ? "stickCheckbox zIndex540"
                              : "cell"
                        }
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        }
      </table>
    </div>
  );

  const makeJobData = (data) => {
    let list = [];
    data.map((el) => {
      list.push({
        id: el.job_id,
        name: el.job_name,
      });
      return true;
    });
    return list;
  };

  const makeAgentData = (data) => {
    let list = [];
    data.map((el) => {
      list.push({
        id: el.agent_id,
        name: el.agent_name,
      });
      return true;
    });
    return list;
  };

  useEffect(() => {
    Axios.post(`${UrlLinks.baseUrl}${UrlLinks.ringgaiUrls.jobListing}`)
      .then((response) => {
        setJobList(makeJobData(response.data.response));
      })
      .catch((err) => {
        showToast("error", "Could not able to fetch job listing");
      });
  }, []);

  useEffect(() => {
    if (selectedJobOption.id === "all") return;
    setSelectedBotOption({
      id: "all",
      name: "Choose Bot",
    })

    Axios.post(
      `${UrlLinks.baseUrl}${UrlLinks.ringgaiUrls.agentListing}?job_id=${selectedJobOption.id}`
    )
      .then((response) => {
        setAgentList(makeAgentData(response.data.response));
      })
      .catch((err) => {
        showToast("error", "Could not able to fetch job listing");
      });
  }, [selectedJobOption]);

  const handleSearch = () => {
    getPaymentListing(perPage, currentPage);
  };

  const loader = (
    <div style={{ margin: "130px auto" }}>
      <ScaleLoader height={70} width={10} color={"#1C4980"} />
    </div>
  );

  return (
    <Styles>
      <Grid container className={styles.pageWrapper}>
        <Grid item xs={12} className={styles.headerRow}>
          Recruitment Voice Bot
          <JobFilter
            uniqueKey="ringgAiJobList"
            jobList={jobList}
            filters={[]}
            setFilters={() => { }}
            selectedOption={selectedJobOption}
            setSelectedOption={setSelectedJobOption}
            placeholder="Type or search the jobs"
          />
          <JobFilter
            uniqueKey="ringgAiAgentList"
            jobList={agentList}
            disabled={selectedJobOption.id === "all"}
            filters={[]}
            setFilters={() => { }}
            selectedOption={selectedBotOption}
            setSelectedOption={setSelectedBotOption}
            placeholder="Type or search the jobs"
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          className={`${styles.actionBarSearch} ${selectedBotOption.name === "Choose Bot"
            ? styles.actionBarSearchDisabled
            : ""
            }`}
        >
          <SearchBar
            uniqueId="recruitmentDashboard"
            searchBy={searchBy}
            setSearchBy={setSearchBy}
            searchError={selectedBotOption.name === "Choose Bot"}
            handleSearch={handleSearch}
            handleSearchClose={handleSearchClose}
            placeholder="Search by name or phone number"
            buttonName="Search"
          />
        </Grid>

        <Grid
          item
          xs={12}
          className={`${styles.subNavTabs} ${selectedBotOption.name === "Choose Bot"
            ? styles.subNavTabsDisabled
            : ""
            }`}
        >
          <Tabs
            value={tabValue}
            onChange={(e, newIndex) => handleTabChange(e, newIndex)}
            aria-label="voicebot status tabs"
            className={`${classes.tabs} ${styles.tabContainer}`}
            textColor="primary"
            indicatorColor="primary"
            TabIndicatorProps={{
              style: {
                background:
                  selectedBotOption.name === "Choose Bot"
                    ? "#A7A7A7"
                    : "#1C4980",
              },
            }}
          >
            {tabsData.map((tab, index) => (
              <Tab
                key={index}
                value={tab.value}
                label={tab.label}
                className={
                  selectedBotOption.name === "Choose Bot"
                    ? styles.tabDisabled
                    : styles.tab
                }
                disabled={
                  selectedBotOption.name === "Choose Bot" ? true : false
                }
                {...a11yProps(index)}
              />
            ))}
          </Tabs>
          <div className={styles.actionBarControls}>
            {
              <button
                onClick={() => setOpenHistoryModal(true)}
                className={
                  data.length === 0 || selectedBotOption.name === "Choose Bot"
                    ? styles.startAICallButtonDisabled
                    : styles.startAICallButton
                }
                disabled={
                  data.length === 0 || selectedBotOption.name === "Choose Bot"
                }
              >
                View History
              </button>
            }
            <div className={styles.updateStatusButton}>
              <ActionsDropdown
                uniqueKey="recruitmentDashboard"
                actions={uploadAction}
                handleActions={handleActions}
                actionList={actionList}
                isRowSelected={
                  selectedBotOption.name === "Choose Bot" ? true : false
                }
                dropdownName="Actions"
              />
            </div>
          </div>
        </Grid>
        {loading ? (
          loader
        ) : data.length === 0 || selectedBotOption.name === "Choose Bot" ? (
          <div className={styles.noRecord}>
            <img src={NoRecord} alt="noRecord" />
            <span
              style={{ fontSize: "22px", fontWeight: "500", color: "#2e2e2e" }}
            >
              No records found
            </span>
            {selectedBotOption.name === "Choose Bot" && (
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "400",
                  color: "#757575",
                  paddingTop: "10px",
                }}
              >
                Please select a Job
              </span>
            )}
          </div>
        ) : (
          <Grid item xs={12} className="paddingTop16">
            {table}
            <Pagination
              rowsperpage={perPage}
              pageNo={currentPage}
              totalElements={totalRows}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
              handlePerRowsChange={handlePerRowsChange}
            />
          </Grid>
        )}

        {openHistoryModal && (
          <HistoryModal
            uniqueKey="recruitmentDashboard"
            open={openHistoryModal}
            setOpen={setOpenHistoryModal}
            url={`${urlLinks.baseUrl}${urlLinks.ringgaiUrls.viewHistory
              }?agent_id=${selectedBotOption.id !== "all" ? selectedBotOption.id : ""
              }`}
          />
        )}
        {openUploadLeadModal && (
          <OnboardingModal
            openOnboardingModal={openUploadLeadModal}
            setOpenOnboardingModal={setOpenUploadLeadModal}
            showToast={showToast}
            updateMyData={updateMyData}
            title="Upload Leads to Start Calling"
            uniqueKey="uploadLeadsRingai"
            templateButton="Download File Template"
            url={`${UrlLinks.baseUrl}${UrlLinks.ringgaiUrls.initiateCalls}?agent_id=${selectedBotOption.id}`}
            fileName="Invalid MPA data"
            fileTypeWarning="Only .xls and .xlsx are allowed"
            buttonName="Start AI Call"
            setIsInitiated={setIsInitiated}
          />
        )}

        {isInitiated.id === "initiated" && isInitiated.flag && (
          <CallInitiatedModal
            openConfirmationDialog={isInitiated}
            setOpenConfirmationDialog={setIsInitiated}
            title="Voicebot calling in progress"
            content="The call is being placed in the background. You may close this popup anytime"
          />
        )}
      </Grid>
    </Styles>
  );
};
export default RecruitmentDashboard;
